// @import_dependencies_node Import libraries
import { store } from 'app_storage/redux-storage'
// @end

// @import utilities
import { SocketConfigStructure, SocketUtil } from 'app_utils/socket'
// @end

class WebSocketService{
  static myInstance: WebSocketService | null = null
  static socket:SocketUtil | null = null

  static getInstance = () => {
    if(WebSocketService.myInstance === null){
      WebSocketService.myInstance = new WebSocketService()
      const socketConfig: SocketConfigStructure = {
        endpoint: 'main_socket',
        token: store.getState().auth.user?.token as string
      }
      WebSocketService.socket = new SocketUtil(socketConfig)
    }
    return WebSocketService.myInstance
  }

  public getSocketInstance(){
    return WebSocketService.socket
  }

  handleOnConnect = () => {
    console.log('Socket conectado')
  }

}

export default WebSocketService
